import classNames from "classnames";
import dayjs from "dayjs";
import { useEffect, useState } from "react";
import { useTranslation } from "react-i18next";

import { SEARCH } from "../../../utils/constants/routes";
import CustomLink from "../../shared/CustomLink";

import styles from "./index.module.scss";

interface ISearchLocalStorage {
  duration: string | null;
  date: string[];
  chosenLocations: [] | Array<Record<string, string>>;
}

function SearchBar() {
  const { t } = useTranslation();

  const [data, setData] = useState<ISearchLocalStorage>({
    duration: "",
    date: [],
    chosenLocations: [],
  });

  useEffect(() => {
    if (!localStorage.getItem("search")) {
      return;
    }

    const search: ISearchLocalStorage = JSON.parse(
      localStorage.getItem("search") ?? "",
    );

    setData(search);
  }, []);

  return (
    <div className={classNames(styles.container)}>
      <div className={classNames(styles.content)}>
        <span>
          <FormatSearchString {...data} />
        </span>

        <CustomLink
          className={styles.searchEditLink}
          to={{ pathname: SEARCH, search: "edit" }}>
          <span>{t("edit search")}</span>
        </CustomLink>
      </div>
    </div>
  );
}

function FormatSearchString({
  chosenLocations,
  date,
  duration,
}: ISearchLocalStorage) {
  const { t } = useTranslation();

  let datesFormat = date
    ?.filter((date) => date)
    .map((date) => dayjs(date).format("MMMM"));

  datesFormat = [...new Set(datesFormat)];

  return (
    <p>
      {t("You searched ")}{" "}
      {chosenLocations?.map((location, index) => (
        <strong key={index}>
          {!!index && " , "}
          {location.name}
        </strong>
      ))}
      {t(" in ")}
      {datesFormat?.map((date, index) => (
        <strong key={index}>
          {!!index && " - "}
          {date}
        </strong>
      ))}
      {duration && (
        <span>
          {" "}
          {t("for")}{" "}
          <strong>
            {duration} {t("nights")}
          </strong>
        </span>
      )}
    </p>
  );
}

export default SearchBar;
